module.exports = __webpack_public_path__ + "img/logo-peace-dark-beta.66001a67.png";